var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_785_2339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.76414 7.78244C9.56414 8.57347 10.3641 9.3645 11.1658 10.1547L11.3716 10.3572L11.1675 10.5606C10.175 11.5417 9.18331 12.5245 8.19247 13.5065L7.11497 14.5744C6.99414 14.6926 6.87747 14.805 6.76997 14.9249C6.57164 15.1456 6.49831 15.4332 6.57497 15.6936C6.65331 15.9614 6.87247 16.1697 7.16414 16.254C7.47164 16.3408 7.73247 16.2623 7.99414 16.0019L12.5333 11.4962L12.5375 11.5004L13.69 10.3572C12.9558 9.63397 12.2225 8.91071 11.4916 8.18581L9.54914 6.26815C9.51414 6.2326 9.46081 6.17805 9.40247 6.10862L9.16247 5.86974C8.75914 5.46967 8.35497 5.06878 7.95081 4.66872C7.78497 4.50754 7.58497 4.41992 7.36997 4.41992C7.27414 4.41992 7.17664 4.43645 7.07664 4.47034C6.74164 4.58193 6.54747 4.81916 6.51497 5.16136C6.47914 5.52753 6.72831 5.77138 6.82081 5.86395L8.76414 7.78244Z",
    fill: "#7D7D7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_785_2339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/rightArrowIcon.a29ead50.svg";
export { ForwardRef as ReactComponent };